import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=48171c2c&scoped=true&"
var script = {}
import style0 from "./statistics.vue?vue&type=style&index=0&id=48171c2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48171c2c",
  null
  
)

export default component.exports